import React from 'react';
import PanelAlert from '@/shared/components/PanelAlert';

const FindReplacePanelAlert = ({ selectedRows, selectedUploadRows, matchCount }) => {
  const prepFileCount = selectedRows?.length || 0;
  const uploadFileCount = selectedUploadRows?.length || 0;
  const totalCount = prepFileCount + uploadFileCount;

  if (totalCount === 0) {
    return (
      <PanelAlert
        severity="warning"
        primaryMessage="Select structures to use find and replace"
        secondaryMessage="Find and replace will search and update selected fields"
      />
    );
  }

  let primaryMessage = `${totalCount} structure${totalCount !== 1 ? 's' : ''} selected`;
  if (prepFileCount > 0 && uploadFileCount > 0) {
    primaryMessage += ` (${prepFileCount} existing, ${uploadFileCount} pending upload)`;
  }

  let secondaryMessage = 'Enter find text and select fields to search';
  if (matchCount > 0) {
    secondaryMessage = `Found ${matchCount} match${matchCount !== 1 ? 'es' : ''} in selected fields`;
  }

  return (
    <PanelAlert
      severity={matchCount > 0 ? "success" : "info"}
      primaryMessage={primaryMessage}
      secondaryMessage={secondaryMessage}
    />
  );
};

export default FindReplacePanelAlert;